const Footer = () => {
    return (
        <div style={{textAlign: 'center', padding: '10px', backgroundColor: '#f1f1f1', marginTop: '20px'}}>
            Made with ❤️ by
            <a
                href="https://www.linkedin.com/in/manan12/"
                style={{cursor: 'pointer'}}
                >
                Limited Manan
                </a>
        </div>

    )
}

export default Footer;